import { style } from '@vanilla-extract/css';

export const rssContainer = style({
  paddingLeft: 'var(--wt-padding)',
  paddingRight: 'var(--wt-padding)',
  paddingTop: '16px',
  paddingBottom: '16px',
  display: 'grid',
  gridTemplateColumns: 'repeat(var(--number-of-columns), minmax(0, 1fr))',
  gap: '2rem',
  '@media': {
    '(max-width: 767px)': {
      gridTemplateColumns: 'repeat(1, minmax(0, 1fr))',
    },
  },
});

export const articleWrapper = style({
  display: 'flex',
  gap: '0.5rem',
});

export const articleContent = style({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: '1',
});

/** Inner wrapper matching email / Write preview `rss_text_box` (text + optional padding). */
export const rssTextBox = style({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'stretch',
  gap: '1rem',
});

export const heading = style({
  textAlign: 'var(--rss-text-align, left)',
  fontSize: 'var(--wt-h2-font-size)',
  fontFamily: 'var(--wt-rss-title-font-family)',
  color: 'var(--post-section-text-color, var(--site-theme-text-on-background-color, var(--wt-rss-title-font-color)))',
  lineHeight: 'var(--wt-rss-title-line-height)',
  fontWeight: 'var(--wt-rss-title-font-weight)',
  margin: '0',
});

export const headlineList = style({
  listStyleType: 'disc',
  margin: '0',
  paddingLeft: '1.5rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  textAlign: 'left',
});

export const headlineListHeading = style({
  display: 'inline',
});

export const categoriesContainer = style({
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
  flexWrap: 'wrap',
  justifyContent: 'var(--rss-categories-justify, flex-start)',
});

export const category = style({
  backgroundColor: '#ebf8ff',
  color: '#2c5282',
  borderColor: '#d1d5db',
  borderWidth: '1px',
  borderRadius: '4px',
  boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.05)',
  display: 'inline-block',
  textAlign: 'center',
  fontSize: '12px',
  fontWeight: 'normal',
  lineHeight: '14px',
  padding: '5px 8px',
});

export const byline = style({
  textAlign: 'var(--rss-text-align, left)',
  color: 'var(--post-section-text-color, var(--site-theme-text-on-background-color, var(--wt-rss-body-font-color)))',
  fontFamily: 'var(--wt-rss-body-font-family)',
  fontWeight: 'var(--wt-rss-body-font-weight)',
  lineHeight: 'var(--wt-rss-body-line-height)',
});

export const pubDate = style({
  textAlign: 'var(--rss-text-align, left)',
  color: 'var(--post-section-text-color, var(--site-theme-text-on-background-color, var(--wt-rss-body-font-color)))',
  fontFamily: 'var(--wt-rss-body-font-family)',
  fontWeight: 'var(--wt-rss-body-font-weight)',
  lineHeight: 'var(--wt-rss-body-line-height)',
});

export const paragraph = style({
  textAlign: 'var(--rss-text-align, left)',
  fontSize: 'var(--wt-paragraph-font-size)',
  fontFamily: 'var(--wt-rss-body-font-family)',
  fontWeight: 'var(--wt-rss-body-font-weight)',
  lineHeight: 'var(--wt-rss-body-line-height)',
  color: 'var(--post-section-text-color, var(--site-theme-text-on-background-color, var(--wt-rss-body-font-color)))',
});

export const ctaContainer = style({
  textAlign: 'var(--cta-alignment)',
});

export const ctaLink = style({
  fontWeight: 'var(--wt-rss-cta-link-font-weight)',
  fontStyle: 'var(--wt-rss-cta-link-font-style)',
  textDecoration: 'none',
  borderBottomStyle: 'solid',
  borderBottomWidth: 'var(--wt-rss-cta-link-border-width, 0)',
  borderBottomColor: 'var(--wt-rss-cta-link-underline-color, transparent)',
  color:
    'var(--post-section-text-color, var(--site-theme-text-on-background-color, var(--wt-rss-cta-link-font-color)))',
});

export const cta = style({
  color: 'var(--wt-rss-cta-button-font-color)',
  fontFamily: 'var(--wt-button-font)',
  backgroundColor: 'var(--wt-rss-cta-button-background-color)',
  border: 'solid var(--wt-rss-cta-button-border-width) var(--wt-rss-cta-button-border-color)',
  borderRadius: 'var(--wt-rss-cta-button-border-radius)',
  padding: '0px 14px',
  fontSize: 'var(--wt-paragraph-font-size)',
  lineHeight: '42px',
  cursor: 'pointer',
  width: 'fit-content',
});

export const dividerContainer = style({
  padding: 'var(--wt-content-break-y-margin) 0',
});

export const divider = style({
  width: 'var(--wt-content-break-width)',
  margin: '0 auto',
  borderTop: 'var(--wt-content-break-thickness) var(--wt-content-break-style) var(--wt-content-break-color)',
});
